export default {
  changeToken (state, token) {
    // sessionStorage.setItem('token', token)
    state.token = token
  },
  changeDeviceType (state, deviceType) {
    state.deviceType = deviceType
  }
}
